import { ESdChangeReason, RightPanelType, ViewPart, Visibility } from "@kuika/kuika-cl-model";
import { IWithSDProps, withSD } from "../../../shared/hoc/screen-design-consumer";
import { PureSdComponent } from "../../../shared/pure-sd";
import KuikaButton from "../../ui-kit/kuika-button/kuika-button";
import KuikaSvg from "../../ui-kit/kuika-svg/kuika-svg";
import KuikaTooltip from "../../ui-kit/kuika-tooltip/kuika-tooltip";

export interface IPropertiesButtonState {}

export interface IPropertiesButtonProps {}

class PropertiesButton extends PureSdComponent<IPropertiesButtonProps & IWithSDProps, IPropertiesButtonState> {
  constructor(props: IPropertiesButtonProps & IWithSDProps) {
    super(props);
    this.state = {};
  }

  render() {
    const buttonElement = (
      <KuikaButton
        data-testid="workflowPropertiesButton"
        type="tertiary"
        size="md"
        isIcon
        color="neutral"
        active={
          this.props.sd.getActiveRightPanel() === RightPanelType.Properties ||
          this.props.sd.getActiveRightPanel() === RightPanelType.AdvancedProperties
        }
        onClick={() => this.props.sd.setActiveRightPanelByClick(RightPanelType.Properties)}
      >
        <KuikaSvg name="adjustments-horizontal" width={18} height={18} pointer />
      </KuikaButton>
    );

    // The tooltip-less variant used to be for the workflow state, which no longer renders this
    // button at all (see ViewPart.PropertiesButton) — so every remaining host gets the tooltip.
    return (
      <>
        {this.props.sd.getVisibility(ViewPart.PropertiesButton) === Visibility.Visible && (
          <KuikaTooltip position="left" content="Properties">
            {buttonElement}
          </KuikaTooltip>
        )}
      </>
    );
  }

  checkNeedRender = (changeReason: ESdChangeReason): boolean => {
    if (
      changeReason === ESdChangeReason.ChangeSelectedDiByCanvasFrame ||
      changeReason === ESdChangeReason.ChangeSelectedDiByTools ||
      changeReason === ESdChangeReason.DragDropDi ||
      changeReason === ESdChangeReason.DragDropBlock
    ) {
      return true;
    }
    return false;
  };
}

const propertiesButton = withSD<IPropertiesButtonProps>(PropertiesButton);
export { propertiesButton as PropertiesButton };
